import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {JyExtendObjectService} from "../../../routes/jy-extend-field/extend-field/jy-extend-object.service";
import {NgForm} from "@angular/forms";

/**
 * 附件组件
 */
@Component({
  selector: 'extend-field-form',
  templateUrl: './extend-field-form.component.html'
})
export class ExtendFieldFormComponent implements OnInit {

  data: any = {};

  @ViewChild('extendFieldForm') extendFieldForm: NgForm;
  configData: any = {};

  @Input() isEdit: boolean;
  @Input() entityName: string;
  @Input() fieldgroupMark:string;
  @Input()
  set extendFieldData(data: any) {
    this.data = data;
    this.initLongTextFiled();
    this.extendFieldDataChange.emit(this.extendFieldData);
  }

  get extendFieldData() {
    return this.data;
  }

  @Output() extendFieldDataChange = new EventEmitter();


  constructor(private jyExtendObjectService: JyExtendObjectService) {

  }

  ngOnInit() {
    this.jyExtendObjectService.getBizTableDetail(this.entityName).subscribe(data => {
      this.configData = data;
    })
  }


  initLongTextFiled() {
    if (this.configData.bizFields) {
      this.configData.bizFields.forEach(field => {
        let num = Number(field.fieldName.replace('field', ''));
        if (45 < num) {
          if (!this.extendFieldData[field.fieldName]) {
            this.extendFieldData[field.fieldName] = {};
          }
        }
      })
    }
  }

  public validateForm(): boolean {
    for (let item in this.extendFieldForm.controls) {
      this.extendFieldForm.controls[item].markAsDirty();
      this.extendFieldForm.controls[item].updateValueAndValidity();
    }
    if (this.extendFieldForm.valid) {
      return true;
    }
    return false;
  }

//  判断组件宽度
@ViewChild('extend') extendEle;
}
